<template>
  <b-link
    to="/"
  >
    <b-img
      :style="'width: ' + width"
      :src="appLogoImage"
      alt="Indetec campus virtual"
    />
  </b-link>
</template>

<script>
import {
  BLink, BImg,
} from 'bootstrap-vue'
import { $themeConfig } from '@themeConfig'

export default {
  components: {
    BLink,
    BImg,
  },
  props: {
    width: {
      type: String,
      default: '40%',
    },
  },
  setup() {
    const { appLogoImage } = $themeConfig.app

    return { appLogoImage }
  },
}
</script>
